import MyContext from "../../../contexts/MyContext";
import { TicketForm3 } from "../ticket-forms/TicketForm3";
export const Slide3 = (props) => {
  return (
    <MyContext.Consumer>
      {(context) => (
        <div hidden={context.activeSlide !== 2}>
          <TicketForm3 {...props} />
        </div>
      )}
    </MyContext.Consumer>
  );
};
